(() => {
  // Prevent duplicate script execution when section is duplicated on the same page.
  if (window.__metiProductIngredientsCarouselScriptLoaded) {
    if (typeof window.__metiInitProductIngredientsCarousel === 'function') {
      window.__metiInitProductIngredientsCarousel();
    }
    return;
  }
  window.__metiProductIngredientsCarouselScriptLoaded = true;

class ProductIngredientsCarousel {
  constructor(slider) {
    this.slider = slider;
    this.viewport = slider.querySelector('.product-ingredients-carousel__viewport');
    this.track = slider.querySelector('.product-ingredients-carousel__track');
    this.slides = Array.from(slider.querySelectorAll('.product-ingredients-carousel__slide'));
    this.prevButton = slider.querySelector('.product-ingredients-carousel__arrow--prev');
    this.nextButton = slider.querySelector('.product-ingredients-carousel__arrow--next');
    this.desktopSlides = Number(slider.dataset.desktopSlides) || 4;
    this.mobileSlides = Number(slider.dataset.mobileSlides) || 1;
    this.currentIndex = 0;
    this.maxIndex = 0;
    this.slideWidth = 0;
    this.slideGap = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;

    if (!this.viewport || !this.track || this.slides.length === 0 || !this.prevButton || !this.nextButton) return;

    this.handleResize = this.handleResize.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this.prevButton.addEventListener('click', this.handlePrev);
    this.nextButton.addEventListener('click', this.handleNext);
    this.viewport.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    this.viewport.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    window.addEventListener('resize', this.handleResize);

    this.refresh(false);
  }

  getVisibleSlides() {
    if (window.matchMedia('(min-width: 990px)').matches) return this.desktopSlides;
    return this.mobileSlides;
  }

  refresh(animate = false) {
    this.visibleSlides = this.getVisibleSlides();
    this.slider.style.setProperty('--visible-slides', String(this.visibleSlides));

    const trackStyles = window.getComputedStyle(this.track);
    this.slideGap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
    this.maxIndex = Math.max(0, this.slides.length - this.visibleSlides);
    this.currentIndex = Math.min(this.currentIndex, this.maxIndex);

    this.goTo(this.currentIndex, animate);
    this.updateButtons();
  }

  goTo(index, animate = true) {
    this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));

    if (!animate) this.track.style.transition = 'none';

    const shift = this.currentIndex * (this.slideWidth + this.slideGap);
    this.track.style.transform = `translate3d(-${shift}px, 0, 0)`;

    if (!animate) {
      window.requestAnimationFrame(() => {
        this.track.style.transition = '';
      });
    }

    this.updateButtons();
  }

  updateButtons() {
    const singlePage = this.maxIndex === 0;
    this.slider.classList.toggle('is-single-page', singlePage);
    this.prevButton.disabled = singlePage || this.currentIndex === 0;
    this.nextButton.disabled = singlePage || this.currentIndex >= this.maxIndex;
  }

  handlePrev() {
    this.goTo(this.currentIndex - 1);
  }

  handleNext() {
    this.goTo(this.currentIndex + 1);
  }

  handleResize() {
    this.refresh(false);
  }

  handleTouchStart(event) {
    this.touchStartX = event.changedTouches[0].clientX;
  }

  handleTouchEnd(event) {
    this.touchEndX = event.changedTouches[0].clientX;
    const delta = this.touchStartX - this.touchEndX;
    if (Math.abs(delta) < 45) return;

    if (delta > 0) {
      this.handleNext();
    } else {
      this.handlePrev();
    }
  }
}

function initProductIngredientsCarousel() {
  const sliders = document.querySelectorAll('.product-ingredients-carousel__slider');
  sliders.forEach((slider) => {
    if (slider.dataset.ingredientsInitialized === 'true') return;
    slider.dataset.ingredientsInitialized = 'true';
    new ProductIngredientsCarousel(slider);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductIngredientsCarousel);
} else {
  initProductIngredientsCarousel();
}

document.addEventListener('shopify:section:load', initProductIngredientsCarousel);
window.__metiInitProductIngredientsCarousel = initProductIngredientsCarousel;
})();
